import React from 'react'
//import { withRouter } from 'react-router-dom'

class Favorites extends React.Component {
  render () {
    return (
      <div className='home'>
        <div className='render-body'>
          <div className='iframe-container relative'>
              This is favorite body 
          </div>
        </div>
      </div>
    )
  }
}
export default Favorites
//export default withRouter(Favorites)
